
import { paymentStore } from "@/stores/payment/payment";

export async function affirmPayNow(createPlanData){
    const storePayment = paymentStore();
    const {$paymentTypeGtag} = useNuxtApp();
    const pay_type = storePayment.getPayType();

    storePayment.setLoaderStatus(false);
    await affirm.checkout(createPlanData)

    affirm.checkout.open({
        onFail: (error) => {
            $paymentTypeGtag(pay_type)
            storePayment.setLoaderStatus(false);
            storePayment.mountErrorModalV2({errorType: 'transactionClosed'});
        },
        onSuccess: (checkout) => {
            
            let code = ''
            let intent = ''
            let pay_type = 8
            let payment_method_nonce = checkout.checkout_token
            $paymentTypeGtag(pay_type)
            
            storePayment.createCharge({ data:{ code, intent, pay_type, payment_method_nonce, amount: createPlanData.total } })
            storePayment.setLoaderStatus(false);
        },
        onOpen: (token) => {
            
        },
        onValidationError: (checkout_validation_error) => {
            $paymentTypeGtag(pay_type)
            storePayment.setLoaderStatus(false);

            let msg = `Error occurred. ${checkout_validation_error.message}`

            storePayment.mountErrorModalV2({errorType: 'affirmValidationError', errorMessage :msg});
        }
    });
}

export async function afterPayNow(createPlanData){

    const storePayment = paymentStore();
    const {$paymentTypeGtag} = useNuxtApp();
    const pay_type = storePayment.getPayType();
    const cartData = storePayment.getCartData();

    storePayment.setLoaderStatus(true);

    AfterPay.initialize({countryCode: createPlanData.countryCode});
    
    AfterPay.open();
    AfterPay.onComplete = (event) =>{


        if (event.data.status == "CANCELLED") {
            storePayment.mountErrorModalV2({errorType: 'transactionClosed'});
        }

        if (event.data.status == "SUCCESS") {

            storePayment.createCharge({ data: { code: '', intent: '', pay_type: 13, payment_method_nonce: event.data.orderToken, amount: cartData.total } })
            storePayment.setLoaderStatus(false);

        } else {
            // The customer cancelled the payment or closed the popup window.
            $paymentTypeGtag(pay_type)
            storePayment.setLoaderStatus(false);
            storePayment.mountErrorModalV2({errorType: 'transactionClosed'});
        }
    }

    AfterPay.transfer({token: createPlanData.token});
}

export function splititModal(createPlanData){

    const storePayment = paymentStore();
    const {$paymentTypeGtag} = useNuxtApp();
    const pay_type = storePayment.getPayType();
        
    if(!createPlanData.CheckoutUrl){
        storePayment.mountErrorModalV2({errorType: 'clientErr'});
    }

    storePayment.setLoaderStatus(true);
    
    Splitit.Iframe.setup({
        env: process.env.splititStatus,
        url: createPlanData.CheckoutUrl,
        onError: (error) => {
            
            $paymentTypeGtag(pay_type)
            storePayment.setLoaderStatus(false);

            storePayment.mountErrorModalV2({errorType: 'clientErr'});
        },
        onSuccess: (dataSuccess) => {
            
            if(dataSuccess.isSuccess){
                $paymentTypeGtag(pay_type)
                storePayment.createCharge({ data: { 
                        payment_method_nonce: createPlanData.InstallmentPlanNumber, 
                        token: createPlanData.token, 
                        pay_type: 5,
                        amount: createPlanData.Amount
                    } 
                })
                storePayment.setLoaderStatus(false);
            }
        },
        onCancel: () => {
            storePayment.setLoaderStatus(false);
            $paymentTypeGtag(pay_type)
            storePayment.mountErrorModalV2({errorType: 'transactionClosed'});
        }
    }).show()
}

export function payBankWire(createPlanData){
    const storePayment = paymentStore();
    const {$paymentTypeGtag} = useNuxtApp();
    const pay_type = storePayment.getPayType();
    const cartData = storePayment.getCartData();

    $paymentTypeGtag(pay_type)
    const data = { 
        payment_method_nonce: '', 
        pay_type: 9, 
        amount: cartData.total.toFixed(2)
    }
    storePayment.createCharge({ data })
}

export function payTelephone(createPlanData){
        const storePayment = paymentStore();
        const {$paymentTypeGtag} = useNuxtApp();
        const pay_type = storePayment.getPayType();
        const cartData = storePayment.getCartData();

        $paymentTypeGtag(pay_type)
        const data = { 
            payment_method_nonce: '', 
            pay_type: 7, 
            amount: cartData.total.toFixed(2)
        }
        storePayment.createCharge({ data })
}